import { mapProps } from 'recompose';
import { Element } from 'react-scroll';

const ScrollElement = mapProps(({ name, children }) => ({
    name: `scroll.${name}`,
    children,
}))(Element);

export default ScrollElement;
